<template>
  <div style="width: 1600px">
    <el-form ref="form" :model="form" label-width="153px">
      <el-row>
        <el-col :span="17" style="width: 953px; height: 40px">
          <el-form-item :label="$t('t.title')">
            <el-input spellcheck="false" v-model="form.name1"></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :span="5"
          class="cus-col-styl"
          style="width: 25.83333%; line-height: 40px"
          >{{ $t("c.a") }}</el-col
        >
      </el-row>
    </el-form>
    <el-form ref="form" :model="form" label-width="153px">
      <el-row>
        <el-col :span="17" style="width: 953px; height: 120px">
          <el-form-item :label="$t('t.desc')">
            <el-input spellcheck="false" type="textarea" v-model="form.content1"></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :span="5"
          class="cus-col-styl"
          style="width: 26.83333%; line-height: 24px"
          >{{ $t("c.b") }}</el-col
        >
      </el-row>
    </el-form>
    <el-form ref="form" :model="form" label-width="153px" style="min-height:270px;margin-bottom:0">
      <el-row style="min-height:270px">
        <el-col :span="16" style="width: 807px;">
          <el-form-item :label="$t('t.upload')" prop="Video" style="margin-bottom:8px;">
            <!-- action必选参数, 上传的地址 新增 -->

            <el-upload
              class="avatar-uploader el-upload--text"
              :action="pic_upload"
              :show-file-list="false"
              :on-success="handleVideoSuccess"
              :before-upload="beforeUploadVideo"
              :on-progress="uploadVideoProcess"
              :data="qiniuData"
            >
              <video
                v-if="videoForm.Video && videoFlag == false"
                :src="videoForm.Video"
                class="avatar"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
              <i
                v-else-if="!videoForm.Video && videoFlag == false"
                class="el-icon-video-camera avatar-uploader-icon-video"
              ></i>
              <div
                class="video-text"
                v-if="videoFlag == false && !videoForm.Video"
              >
                <!-- 上传视频 -->
              </div>
              <el-progress
                v-if="videoFlag == true && !videoForm.Video"
                type="circle"
                :percentage="videoUploadPercent"
                class="progress"
              ></el-progress>
            </el-upload>
            <!-- <span
              style="position: absolute; left: 140px; top: 25%; color: #999999"
              >请保证视频格式正确，且不超过500M</span
            > -->
          </el-form-item>
          <el-form-item label="" style="margin-bottom:14px">
            <el-upload
              :multiple="true"
              :action="pic_upload"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-success="handleAvatarSuccessImg"
              :before-upload="beforeAvatarUpload"
              :file-list="imgFileList"
              :data="qiniuData"
            >
              <i class="el-icon-picture avatar-uploader-icon-video"></i>
              <!-- <div class="video-text">图片上传</div> -->
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
        </el-col>
        <el-col
          :span="5"
          class="cus-col-styl"
          style="width: 36.83333%; line-height: 24px"
        >
          <el-form-item>
             <div class="margin-bottom: 5px; line-height: 23px;">{{ $t("c.c.0") }}</div>
          <div style="margin-bottom: 5px;  line-height: 23px;">{{ $t("c.c.1") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.c.2") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.c.3") }}</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-form ref="form" :model="form" label-width="68px" style="margin-top:4px">
      <el-row>
        <el-col
          :span="3"
          style="width: 143px; text-align: center; line-height: 39px"
          >{{ $t("t.other") }}</el-col
        >
        <el-col :span="15" class="cus-item-text" style="width: 823px">
          <el-form-item :label="$t('t.Channel')">
            <el-select
              v-model="form.channelMainId"
              filterable
              :placeholder="$t('t.placeholderA')"
              @change="getChange"
            >
              <el-option
                v-for="item in channelList"
                :key="item.channelMainId"
                :label="item.name"
                :value="item.channelMainId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5" class="cus-col-styl" style="width: 26.83333%; ">
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.d.0") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.d.1") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.d.2") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.d.3") }}</div>
          <div style="margin-bottom: 5px;line-height: 23px;">{{ $t("c.d.4") }}</div></el-col
        >
      </el-row>
      <el-row style="margin-top: 30px">
        <el-col
          :span="3"
          style="
            width: 143px;
            text-align: center;
            line-height: 39px;
            visibility: hidden;
          "
          >其他</el-col
        >
        <el-col :span="15" class="cus-item-text" style="width: 823px">
          <el-form-item :label="$t('t.Source')">
            <el-input v-model="form.source"></el-input> </el-form-item
        ></el-col>
        <el-col :span="5" class="cus-col-styl" style="width: 26.83333%; ">{{ $t("c.e") }}</el-col>
      </el-row>
    </el-form>
    <el-button
      @click="handleSaveClick"
      style="
        margin: 20px 40px;
        min-width: 104px;
        height: 32px;
        background: #65b0ff;
        line-height: 0.2;
        position: absolute;
        left: 480px;
        border-radius: 0;
      "
      type="primary"
      >{{ $t("t.btn") }}</el-button
    >
  </div>
</template>
 <script>
import {
  pic_upload,
  publish,
  getUserInfo,
  get_hot_new_channel_list_all as channelList,
  uploadToken,
} from "@/api";
export default {
  name: "addconsult",
  data() {
    return {
      language: 1,
      form: {
        name1: "",
        content1: "",
        channelMainId: "",
        share: "",
        source: "",
        channelName: "",
      },
      videoForm: {
        Video: "",
      },
      videoFlag: false,
      videoUploadPercent: 0,
      dialogImageUrl: "",
      dialogVisible: false,
      imgFileList: [],
      channelList: [],
      fileListImg: [],
      qiniuData: {
        bucketName: "",
        key: "",
        token: "",
      },
      qiniuaddr: "http://qntest.hoptip.com",
    };
  },
  computed: {
    pic_upload() {
      return pic_upload;
    },
  },
  mounted() {
    console.log(this.$i18n);
    this.requestuploadToken();
    this.requestGetUserInfo();
  },
  methods: {
    getChange(val) {
      let obj = {};
      obj = this.channelList.find((item) => {
        return item.channelMainId == val;
      });
      this.form.channelName = obj.name;
    },
    //获取用户信息
    requestGetUserInfo() {
      getUserInfo().then((res) => {
        this.form.share = res.data.username;
        this.language = res.data.language;
        console.log(res.data.language)
        console.log(this.$i18n.locale)
        let la =  res.data.language == 1 ? this.$i18n.locale = 'zh' :  res.data.language == 2 ? this.$i18n.locale = 'en' :  res.data.language == 3 ? this.$i18n.locale = 'de' :  res.data.language == 4 ? this.$i18n.locale = 'ja' : 'zh'
        localStorage.setItem("language", la);
        this.requestChannelList();
      });
    },
    //获取所有频道
    requestChannelList() {
      let params = {
        language: this.language,
      };
      channelList(params).then((res) => {
        // //console.log(res);
        if (res.code == 200) {
          this.channelList = res.data;
        }
      });
    },
    //获取token
    requestuploadToken() {
      uploadToken().then((res) => {
        //console.log(res);
        (this.qiniuData.key = res.data.key),
          (this.qiniuData.token = res.data.upToken);
      });
    },
    handleVideoSuccess(res, file) {
      //获取上传视频地址
      //console.log(res);
      let name = file.name.substring(
        file.name.indexOf(".") + 1,
        file.name.length
      );
      if (res.key) {
        this.videoForm.Video = `${this.qiniuaddr}/${res.key}`;
        this.videoUploadPercent = 0;
        this.videoFlag = false;
      } else {
        this.$message.error("视频上传失败，请重新上传！");
      }
    },
    uploadVideoProcess(event, file, fileList) {
      //console.log(file);
      this.videoFlag = true;
      this.videoUploadPercent = Number(file.percentage.toFixed(0));
    },
    beforeUploadVideo(file) {
      console.log(file);
      let type = file.name.substring(
        file.name.indexOf(".") + 1,
        file.name.length
      );
      console.log(name);
      this.qiniuData.key = `upload_video_${file.uid}.${type}`;
      this.videoForm.Video = "";
      this.videoFlag = true;
      console.log(file);
      const isLt10M = file.size / 1024 / 1024 < 500;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        this.videoFlag = false;
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传视频大小不能超过500MB哦!");
        return false;
      }
    },
    handleRemove(file, fileList) {
      //console.log(file, fileList);
      this.fileListImg.splice(fileList.url, 1);
    },
    handlePictureCardPreview(file) {
      //console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let type = file.name.substring(
        file.name.indexOf(".") + 1,
        file.name.length
      );
      this.qiniuData.key = `upload_pic_${file.uid}.${type}`;
    },
    handleAvatarSuccessImg(res, file) {
      //console.log(res);
      //console.log(file);
      let fileImgUrl = `${this.qiniuaddr}/${res.key}`;
      this.fileListImg.push(fileImgUrl);
    },
    handleSaveClick() {
      if (!this.form.name1 || !this.form.content1) {
        this.$message.error("中文标题和内容不能为空");
        return false;
      }
      if (!this.videoForm.Video && this.fileListImg.join(",").length == 0) {
        this.$message.error("视频和图片必传一个");
        return false;
      }
      if (!this.form.source) {
        this.$message.error("来源不能为空");
        return false;
      }
      if (!this.form.channelMainId) {
        this.$message.error("请选择频道");
        return false;
      }
      let params = {
        language: this.language,
        title: this.form.name1,
        content: this.form.content1,
        video: this.videoForm.Video,
        imgs: this.fileListImg.join(","),
        source: this.form.source,
        shareName: this.form.share,
        channelMainId: this.form.channelMainId,
        channelName: this.form.channelName,
      };
      this.requestSaveList(params);
    },
    requestSaveList(params) {
      publish(params).then((res) => {
        if (res.code == 200) {
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.clear {
  clear: both;
}
html body {
  font-family: Source Han Sans CN;
}
.el-icon-video-camera:before {
  color: #999999;
}
.el-icon-picture:before {
  color: #999999;
}
.cus-col-styl {
  font-size: 14px;
  color: #333333;
  margin-left: 20px;
}
/deep/ .el-form {
  //   width: 727px;
  margin: 20px auto;
  .el-input__inner {
    width: 800px;
    height: 32px;
    border-radius: 0;
  }
  .el-textarea__inner {
    // width: 50vw;
    width: 800px;
    height: 116px;
    border-radius: 0;
   font-family: emoji;
        // font-size: inherit !important;
    color: #606266 !important;
  }
  .el-form-item__label {
    text-align: center;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
  }
}
.avatar {
  width: 120px;
  height: 120px;
}
//    .el-card__body {
//       text-align: center;
// }
.video-text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 0;
}
</style>
<style>
.el-progress-circle svg {
  width: 100px;
  height: 100px;
  margin-top: 10px;
}
.el-upload-list__item {
  width: 120px !important;
  height: 120px !important;
  border: 1px solid #c0ccda;
}
.cus-item-text .el-form-item__label {
  font-size: 14px !important;
  color: #333333 !important;
}
.cus-item-text .el-input__inner {
  width: 750px !important;
}
.el-progress-circle {
  margin: 0 auto;
}
.progress {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 20px;
  text-align: center;
}
.avatar-uploader .el-upload {
  width: 120px;
  height: 120px;
  border-radius: 0 !important;
}
.el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 40px;
  border-radius: 0 !important;
  background-color: white;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar-uploader-icon-video {
  font-size: 28px;
  color: #8c939d;
  width: 36px;
  height: 36px;
  line-height: 126px;
  text-align: center;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>